export default __webpack_public_path__ + "static/app-store-badge-9ac8491a71dc3fd11992051d32893743.png";